import React, { Fragment } from 'react';
import CTMInvoice from '~/pages/CTMInvoice';
import { InvoiceResultMode } from '~/common';
import { Loading } from '~/components';

class ApplyVoucherInvoicePanel extends React.Component {
    render() {
        return <Fragment>
            {this.props.applying && <Loading />}
            <CTMInvoice mode={InvoiceResultMode.ApplyVouchers} onApply={this.props.onApply} applying={this.props.applying} />
        </Fragment>
    }
}

export default ApplyVoucherInvoicePanel;
